import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import InfoBlock from './InfoBlock';
import { breakpoint } from 'utils/mediaQueries';
import BackgroundMobileInfoBlock from 'images/clientCasePage/background/backgroundMobileInfoBlock.svg';
import orangeMark from 'images/clientCasePage/infoBlock/orangeMark.svg';
import purpleMark from 'images/clientCasePage/infoBlock/purpleMark.svg';
import lightBlueMark from 'images/clientCasePage/infoBlock/lightBlueMark.svg';

const ContentBlock = styled(Grid)`
  margin-top: -1rem;
  padding-bottom: 6rem;
  width: 100%;
  position: relative;
  ${breakpoint.down('lg')`
   margin-top: -3rem`};
  ${breakpoint.down('md')` padding-bottom: 8rem; padding-top:4rem`}
  ${breakpoint.down('sm')`
    flex-direction: column;align-items: center`}
  ${breakpoint.down('xs')`
  margin-top: 0;`};
`;
const BackgroundInfoBlock = styled(Grid)`
  opacity: 0;
  background-image: url("${BackgroundMobileInfoBlock}");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  ${breakpoint.down('md')`
  opacity:1;`}
`;
const ImageInfoBlocks = [orangeMark, purpleMark, lightBlueMark];
const InfoBlocks = ({ data: { markdownContent } }) => {
  return (
    <ContentBlock container justify="center">
      {markdownContent.map((block, index) => (
        <InfoBlock
          key={`InfoBlock${index}`}
          data={block}
          image={ImageInfoBlocks[index]}
        />
      ))}
      <BackgroundInfoBlock />
    </ContentBlock>
  );
};
export default InfoBlocks;
